<app-transaction-result-view
[id]="id"
[shouldShowFlow]="false"
[title]="'Actualizar licencia mina'"
[subtitle]="subtitle"
[messageBold]="messageBold"
[message]="message"
[actionButtonText]="actionButtonText"
[actionButtonPath]="actionButtonPath"
secondaryButtonText="Crear una nueva solicitud"
secondaryButtonPath="/license/new"
[breadcrums]="breadcrums"
[variant]="variant"
></app-transaction-result-view>

